import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var WithTimestampClass;
function WithTimestamp() {
  if (WithTimestampClass === VOID) {
    class $ {
      constructor(item, at) {
        var tmp;
        if (at === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = at;
        }
        at = tmp;
        this.dem_1 = item;
        this.eem_1 = at;
      }
      toString() {
        return 'WithTimestamp(item=' + toString(this.dem_1) + ', at=' + this.eem_1.toString() + ')';
      }
      hashCode() {
        var result = this.dem_1 == null ? 0 : hashCode(this.dem_1);
        result = imul(result, 31) + this.eem_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WithTimestamp()))
          return false;
        if (!equals(this.dem_1, other.dem_1))
          return false;
        if (!this.eem_1.equals(other.eem_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WithTimestamp');
    WithTimestampClass = $;
  }
  return WithTimestampClass;
}
var WithTimestampAndLimitClass;
function WithTimestampAndLimit() {
  if (WithTimestampAndLimitClass === VOID) {
    class $ {
      constructor(item, requestedLimit, at) {
        var tmp;
        if (at === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = at;
        }
        at = tmp;
        this.een_1 = item;
        this.fen_1 = requestedLimit;
        this.gen_1 = at;
      }
      weo(item, requestedLimit, at) {
        return new (WithTimestampAndLimit())(item, requestedLimit, at);
      }
      qeo(item, requestedLimit, at, $super) {
        item = item === VOID ? this.een_1 : item;
        requestedLimit = requestedLimit === VOID ? this.fen_1 : requestedLimit;
        at = at === VOID ? this.gen_1 : at;
        return $super === VOID ? this.weo(item, requestedLimit, at) : $super.weo.call(this, item, requestedLimit, at);
      }
      toString() {
        return 'WithTimestampAndLimit(item=' + toString(this.een_1) + ', requestedLimit=' + this.fen_1 + ', at=' + this.gen_1.toString() + ')';
      }
      hashCode() {
        var result = this.een_1 == null ? 0 : hashCode(this.een_1);
        result = imul(result, 31) + this.fen_1 | 0;
        result = imul(result, 31) + this.gen_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WithTimestampAndLimit()))
          return false;
        if (!equals(this.een_1, other.een_1))
          return false;
        if (!(this.fen_1 === other.fen_1))
          return false;
        if (!this.gen_1.equals(other.gen_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WithTimestampAndLimit');
    WithTimestampAndLimitClass = $;
  }
  return WithTimestampAndLimitClass;
}
//region block: exports
export {
  WithTimestampAndLimit as WithTimestampAndLimitv5k4d7fr8du4,
  WithTimestamp as WithTimestamp1a7xpvbvrfq5g,
};
//endregion

//# sourceMappingURL=WithTimestamp.mjs.map
